import { IWebhookPayloadData } from '@services/applications';
import {
  ISystemClientProperties,
  ISystemMemberAddedToAnOfferProperties,
  ISystemMemberBriefAcceptedProperties,
  ISystemMemberBriefSentMessageProperties,
  ISystemMemberDeliverableCompleteProperties,
  ISystemMemberProductOrderCreatedProperties,
  ISystemMemberProductOrderDeliveredProperties,
  ISystemMemberProductOrderRequestSentProperties,
  ISystemMemberProgramApprovedProperties,
  ISystemMemberProgramInvitedMessageProperties,
  ISystemMemberProgramInvitedProperties,
  ISystemMemberProgramRejectedProperties,
  ISystemMemberSalesTrackingBoostValidationProperties,
  ISystemMemberSalesTrackingConversionProperties,
  ISystemMemberSubmitLandingPageProperties,
} from '@services/event';

export interface IAutomationWebhookData extends IWebhookPayloadData {
  properties: ISystemClientProperties
  | ISystemMemberBriefAcceptedProperties
  | ISystemMemberBriefSentMessageProperties
  | ISystemMemberDeliverableCompleteProperties
  | ISystemMemberProductOrderCreatedProperties
  | ISystemMemberProductOrderDeliveredProperties
  | ISystemMemberProductOrderRequestSentProperties
  | ISystemMemberProgramApprovedProperties
  | ISystemMemberProgramInvitedMessageProperties
  | ISystemMemberProgramInvitedProperties
  | ISystemMemberProgramRejectedProperties
  | ISystemMemberSubmitLandingPageProperties
  | ISystemMemberSalesTrackingConversionProperties
  | ISystemMemberSalesTrackingBoostValidationProperties
  | ISystemMemberAddedToAnOfferProperties;
}
